import styled from 'styled-components';
import { pickThemeColor } from '@/theme';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
  min-width: 8rem;
`;

export const StyledIconWrap = styled.div`
  cursor: pointer;
  display: flex;

  svg {
    height: 1.5rem;
    width: 1.5rem;
  }

  path {
    fill: ${pickThemeColor('RED_CORAL')};
  }
`;
